export class TicketModel {
  business: string;
  lastName: string;
  firstName: string;
  email: string;
  subject: string;
  description: string;
}
